import React from "react";
import Card from "react-bootstrap/Card";
import Button from "@components/base/button";
import "../../assets/scss/intel.scss";
import { Col, Row } from "react-bootstrap";
import "../../assets/scss/global.scss";
import SortedBarChart from "../../core/charts/sorted-bar-chart";
import HorizontalBar from "../../core/charts/horizontal-bar-chart";
import ReactTooltip from "react-tooltip";
import NewPieChart from "../../core/charts/newPie";
import TradeRouteTwoLevel from "../../shared/analytics-components/trade-route-two-level";
import TradeRouteThreeLevel from "../../shared/analytics-components/trade-route-three-level";
import TradeRouteFourLevel from "../../shared/analytics-components/trade-route-four-level";
import TopShipmentSection from "../country-components/top-shipments";
import LineChart from "../../core/charts/line-chart_company";
import CategoryAxis from "../../core/compare-trends-charts/category-axis-chart";
import { Info } from "react-feather";
import { getIntelUrl } from "../../utils/intelUrl";
import LocalStorageService from "../../core/services/local-storage.service";
import { analyticsMainLabelOptions } from "../../core/global/global-country-dictionary";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import { trademoTrackingEvents } from "../../core/global/trademo-tracking";
import { generateTrackingObject } from "../../core/global/global-country-functions";
import ChartSkeleton from "../../core/charts/chartSkeleton";
import { ContextData } from "../../containers/shipments/shipments";
import CustomizeAnalytics from "./CustomizeAnalytics";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AnalyticsSideDrawer from "./AnalyticsSideDrawer";
const numFormat = (num) => {
  if (!isNaN(num)) {
    if (!!num && num > 1000000000000) {
      return (num / 1000000000000).toFixed(2) + " Trillion";
    } else if (!!num && num > 1000000000) {
      return (num / 1000000000).toFixed(2) + " Billion";
    } else if (!!num && num > 1000000) {
      return (num / 1000000).toFixed(2) + " Million";
    } else if (!!num && num > 1000) {
      return (num / 1000).toFixed(2) + " Thousand";
    } else return num.toFixed(2);
  } else return num;
};

const localStorageService = LocalStorageService.getService();
class GlobalAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.reference = React.createRef();
  }
  state = {
    isLoaderActive: true,
    analyticsData: [],
    analysisIndexKey: null,
    search_type_options: [{ value: "shipments", label: "Number of Shipments" }],
    mainLabel: null,
    analyticsFieldKeys: [],
    analyticsType: [],
    showFindWidget: false,
    showCustomiseWidget: false,
    selectedIndex: null,
    viewAllTrends: false,
    modalHeading: "",
    isGraphLoader: false,
    isSideBarOpen: true,
  };
  componentDidMount() {
    const mountOrder = this.props.embedReadOnlyAnalytics ? this.props?.graphData?.widgetOrder || [] : (this.props.selectedAnalyticsDashlet?.length > 0 && this.props.selectedAnalyticsDashlet) || this.props?.graphData?.widgetOrder || [];
    this.sortAnalyticsWidgets(mountOrder);
    this.setState(
      {
        analyticsData: this.props.graphData ? this.props.graphData : [],
        analyticsType: this.props.analyticsType ? this.props.analyticsType : [],
        search_type_options: this.props.dropdownOptions ? this.props.dropdownOptions : [{ value: "shipments", label: "Number of Shipments" }],
      },
      () => {
        this.findAnalysisKeyInList(!!this.props && !!this.props.graphData && !!this.props.graphData.analysis && this.props.graphData.analysis !== "" ? this.props.graphData.analysis : "");
      }
    );
    this.setState({
      mainLabel: analyticsMainLabelOptions ? analyticsMainLabelOptions[this.props.graphData.analysis] : this.props.graphData.analysis === "value" ? "USD" : this.props.graphData.analysis === "weight" ? "Weight (kg)" : this.props.graphData.analysis === "teu" ? "TEUs" : "Shipments",
      isLoaderActive: false,
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.embedReadOnlyAnalytics) return;
    const prevOrder = prevProps.selectedAnalyticsDashlet || [];
    const currentOrder = this.props.selectedAnalyticsDashlet || [];
    if (currentOrder.length && JSON.stringify(prevOrder) !== JSON.stringify(currentOrder)) {
      this.sortAnalyticsWidgets(currentOrder);
    }
  }
  sortAnalyticsWidgets = (orderArr) => {
    if (this.props.analyticsItems && Array.isArray(this.props.analyticsItems) && this.props.analyticsItems.length) {
      //analyticsItems is nothing just analytics field mapping which comes from default values
      let analyticsItemsCopy = JSON.parse(JSON.stringify(this.props.analyticsItems));
      let sortedAnalyticsWidgets = [];
      if (this.props.graphData) {
        if (orderArr && Array.isArray(orderArr) && orderArr.length) {
          for (let i = 0; i < orderArr.length; i++) {
            for (let j = 0; j < analyticsItemsCopy.length; j++) {
              if (analyticsItemsCopy[j].key === orderArr[i]) {
                sortedAnalyticsWidgets[i] = JSON.parse(JSON.stringify(analyticsItemsCopy[j]));
                analyticsItemsCopy.splice(j, 1);
                break;
              }
            }
          }
        }
      }
      if (!sortedAnalyticsWidgets.length) {
        sortedAnalyticsWidgets = JSON.parse(JSON.stringify(this.props.analyticsItems));
      }
      let compactWidgets = sortedAnalyticsWidgets.filter((w) => w !== null && w !== undefined);
      this.setState({
        analyticsFieldKeys: JSON.parse(JSON.stringify(compactWidgets)),
      });
    } else {
      this.setState({
        analyticsFieldKeys: [],
      });
    }
  };
  bindGroupByResultValue(data) {
    if (data) {
      this.props.analyticsDataSource(data);
    }
  }
  findAnalysisKeyInList(data) {
    if (!!data && data !== "") {
      let tempValue = "";
      for (let i = 0; i < this.state.search_type_options.length; i++) {
        if (data === this.state.search_type_options[i].value) {
          tempValue = this.state.search_type_options.indexOf(this.state.search_type_options[i]);
          break;
        }
      }
      this.setState({
        analysisIndexKey: tempValue,
      });
    }
  }
  detailModalShow = (data1, data2) => {
    if (!!data1 && data1 !== "") {
      let summaryViewAllReqObj = {
        analyticsViewAllKey: data1,
        analysisOption: this.state.analysisIndexKey ? this.state.search_type_options[this.state.analysisIndexKey].value : this.state.search_type_options[0].value,
      };
      trademoTrackingEvents(this.props?.analyticsCountryID?.toLowerCase()?.replace("-", "_") + data2?.label?.toLowerCase().replace("", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsDashletViewAll, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      this.props.analyticsViewAllData(summaryViewAllReqObj, data2);
    }
  };
  trendsModalShow = (data, currentKeyViewTrendItem) => {
    if (!!data && data !== "") {
      let summaryViewAllReqObj = {
        analyticsViewAllKey: data,
        analysisOption: this.state.analysisIndexKey ? this.state.search_type_options[this.state.analysisIndexKey].value : this.state.search_type_options[0].value,
      };
      trademoTrackingEvents(this.props?.analyticsCountryID?.toLowerCase()?.replace("-", "_") + "_" + currentKeyViewTrendItem?.label?.toLowerCase().replace(" ", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsDashletTrends, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      this.props.fetchSummaryTrendsData(summaryViewAllReqObj, currentKeyViewTrendItem);
    }
  };
  redirectingUser = (data1, data2, data3, data4, data5) => {
    let tempObj = {
      analyticsViewAllKey: !!data1 && data1 !== "" ? data1 : "",
      filter_value1: !!data2 && data2 !== "" ? data2 : "",
      filter_value2: !!data3 && data3 !== "" ? data3 : "",
      filter_value3: !!data4 && data4 !== "" ? data4 : "",
      filter_value4: !!data5 && data5 !== "" ? data5 : "",
      analysisOption: this.state.analysisIndexKey ? this.state.search_type_options[this.state.analysisIndexKey].value : this.state.search_type_options[0].value,
    };
    this.props.analyticsViewAllData(tempObj);
    let appliedLabel = data1;
    for (let i = 0; i < this.state.analyticsFieldKeys.length; i++) {
      if (data1 === this.state.analyticsFieldKeys[i]?.key) {
        appliedLabel = this.state.analyticsFieldKeys[i].label;
        break;
      }
    }
    trademoTrackingEvents(this.props?.analyticsCountryID?.toLowerCase()?.replace("-", "_") + appliedLabel?.toLowerCase().replace("", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsDashletFilter, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
  };
  redirectingTopSection = (data1, data2, data3) => {
    let tempObj = {
      analyticsViewAllKey: !!data1 && data1 !== "" ? data1 : "",
      filter_value1: !!data2 && data2.length !== 0 ? data2 : [],
      filter_value2: !!data3 && data3 !== "" ? data3 : "",
      analysisOption: this.state.analysisIndexKey ? this.state.search_type_options[this.state.analysisIndexKey].value : this.state.search_type_options[0].value,
    };
    let appliedLabel = data1;
    for (let i = 0; i < this.state.analyticsFieldKeys.length; i++) {
      if (data1 === this.state.analyticsFieldKeys[i]?.key) {
        appliedLabel = this.state.analyticsFieldKeys[i].label;
        break;
      }
    }
    trademoTrackingEvents(this.props?.analyticsCountryID?.toLowerCase()?.replace("-", "_") + appliedLabel?.toLowerCase().replace("", "").replaceAll(" ", "_").replaceAll("→", "to") + "_" + trackingEventDictionary.analyticsDashletFilter, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    this.props.analyticsViewAllData(tempObj);
  };
  downloadAnalyticsPDF = () => {
    this.props.downloadPDF({ downloadPDF: true });
  };

  hoverGraphHandler = (index) => {
    this.setState({
      selectedIndex: index,
    });
  };

  onMouseLeaveHandler = () => {
    this.setState({
      selectedIndex: null,
    });
  };
  // below code is for the Fontenf Export
  downloadUSExportsAnalyticsPDF = () => {
    trademoTrackingEvents(trackingEventDictionary.downloadAnalyticsPdf, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));

    this.displayAndHideForDownload("DOWNLOAD");
    setTimeout(() => {
      const analyticsDownloadData = {
        domElement: this.reference.current.innerHTML,
        analyticsData: this.props.entireRequestObject,
        mainLabel: this.state.mainLabel,
        filterList: this.props.filterList,
        appliedState: this.props.appliedState,
        redirectingURL: window.location.pathname,
        includeFilter: this.props.includeFilter,
        excludeFilter: this.props.excludeFilter,
        analyticsCommonData: {
          total_shipments: !!this.state.analyticsData.total_shipments && this.state.analyticsData.total_shipments !== "" ? numFormat(this.state.analyticsData.total_shipments) : null,
          total_teu: !!this.state.analyticsData.total_teu && this.state.analyticsData.total_teu !== "" ? numFormat(this.state.analyticsData.total_teu) : null,
          total_weight: !!this.state.analyticsData.total_weight && this.state.analyticsData.total_weight !== "" ? numFormat(this.state.analyticsData.total_weight) + " Kg" : null,
          total_value: !!this.state.analyticsData.total_value && this.state.analyticsData.total_value !== "" ? numFormat(this.state.analyticsData.total_value) : null,
        },
      };
      localStorageService.setAnalyticsDownloadData(JSON.stringify(analyticsDownloadData));
      setTimeout(() => {
        const url = getIntelUrl() + "analytics-download";
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.click();
        setTimeout(() => {
          this.displayAndHideForDownload("NOT_DOWNLOAD");
        }, 800);
      }, 100);
    }, 1000);
  };
  displayAndHideForDownload(type) {
    if (type === "DOWNLOAD") {
      let removeBlockForPdfelement = document.getElementsByClassName("remove-block-for-pdf");
      for (let i = 0, len = removeBlockForPdfelement.length; i < len; i++) {
        removeBlockForPdfelement[i].style.display = "none";
      }
      let tradeRoutePdfElements = document.getElementsByClassName("trade-route-pdf");
      for (let i = 0, len = tradeRoutePdfElements.length; i < len; i++) {
        tradeRoutePdfElements[i].style.marginTop = "5px";
        tradeRoutePdfElements[i].style.marginBottom = "0px";
        tradeRoutePdfElements[i].style.minHeight = "600px";
        tradeRoutePdfElements[i].style.overflowY = "visible";
        tradeRoutePdfElements[i].style.overflowX = "hidden";
      }
      let analyticsCardBoxPdfElements = document.getElementsByClassName("analytics-card-box");
      for (let i = 0, len = analyticsCardBoxPdfElements.length; i < len; i++) {
        analyticsCardBoxPdfElements[i].style.marginTop = "5px";
        analyticsCardBoxPdfElements[i].style.marginBottom = "0px";
      }
      let amchartGraphPdfElements = document.getElementsByClassName("amcharts-graph-pdf");
      for (let i = 0, len = amchartGraphPdfElements.length; i < len; i++) {
        amchartGraphPdfElements[i].style.marginTop = "5px";
        amchartGraphPdfElements[i].style.paddingTop = "0px";
        amchartGraphPdfElements[i].style.paddingBottom = "0px";
        amchartGraphPdfElements[i].style.minHeight = "260px";
        amchartGraphPdfElements[i].style.marginBottom = "0px";
        amchartGraphPdfElements[i].style.overflowY = "visible";
        amchartGraphPdfElements[i].style.overflowX = "hidden";
      }
      let amchartPiePdfElements = document.getElementsByClassName("pie-chart-pdf");
      for (let i = 0, len = amchartPiePdfElements.length; i < len; i++) {
        amchartPiePdfElements[i].style.minHeight = "400px";
      }

      let topShipmentsPdfElements = document.getElementsByClassName("top-shipments-pdf");
      for (let i = 0, len = topShipmentsPdfElements.length; i < len; i++) {
        topShipmentsPdfElements[i].style.marginTop = "5px";
        topShipmentsPdfElements[i].style.marginBottom = "0px";
        topShipmentsPdfElements[i].style.minHeight = "600px";
        topShipmentsPdfElements[i].style.overflowY = "visible";
        topShipmentsPdfElements[i].style.overflowX = "hidden";
      }
      let tooltipPdfElements = document.getElementsByClassName("__react_component_tooltip");
      for (let i = 0, len = tooltipPdfElements.length; i < len; i++) {
        tooltipPdfElements[i].style.display = "none";
      }
    } else {
      let removeBlockForPdfelement = document.getElementsByClassName("remove-block-for-pdf");
      for (let i = 0, len = removeBlockForPdfelement.length; i < len; i++) {
        removeBlockForPdfelement[i].style.removeProperty("display");
      }
      let tradeRoutePdfElements = document.getElementsByClassName("trade-route-pdf");
      for (let i = 0, len = tradeRoutePdfElements.length; i < len; i++) {
        tradeRoutePdfElements[i].style = {};
      }
      let amchartGraphPdfElements = document.getElementsByClassName("amcharts-graph-pdf");
      for (let i = 0, len = amchartGraphPdfElements.length; i < len; i++) {
        amchartGraphPdfElements[i].style = {};
      }
      let topShipmentsPdfElements = document.getElementsByClassName("top-shipments-pdf");
      for (let i = 0, len = topShipmentsPdfElements.length; i < len; i++) {
        topShipmentsPdfElements[i].style = {};
      }
      let tooltipPdfElements = document.getElementsByClassName("__react_component_tooltip");
      for (let i = 0, len = tooltipPdfElements.length; i < len; i++) {
        tooltipPdfElements[i].style = {};
      }
      let analyticsCardBoxPdfElements = document.getElementsByClassName("analytics-card-box");
      for (let i = 0, len = analyticsCardBoxPdfElements.length; i < len; i++) {
        analyticsCardBoxPdfElements[i].style.marginBottom = "1.5rem";
      }
    }
  }

  setShowFindWidget(value) {
    if (value) {
      this.setState({
        showFindWidget: false,
      });
    } else {
      trademoTrackingEvents(trackingEventDictionary.analyticsTabFindWidgetButtonClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      this.setState({
        showFindWidget: true,
      });
    }
  }
  setShowCustomiseWidget(value) {
    if (value) {
      this.setState({
        showCustomiseWidget: false,
      });
    } else {
      trademoTrackingEvents(trackingEventDictionary.analyticsTabCustomizeWidgetsButtonClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      this.setState({
        showCustomiseWidget: true,
      });
    }
  }
  // End of the above code
  render() {
    return (
      <ContextData.Consumer>
        {(value) => {
          const readOnly = !!this.props.embedReadOnlyAnalytics;
          const disableHeaderSelection = readOnly || !!this.props.disableAnalyticsHeaderSelection;
          const suppressChartFilterInteractions = readOnly && !this.props.enableFilterRedirect;
          const mapFilter = suppressChartFilterInteractions ? () => null : this.redirectingUser.bind(this);
          const mapTopSection = suppressChartFilterInteractions ? () => null : this.redirectingTopSection.bind(this);
          return (
            <div className="container-fluid">
              <div className="!tw-relative">
                {!readOnly && (
                  <div className="row no-gutter results-sort-dropdown mb-3">
                    <div className="col-md-6">
                      <div className="d-flex align-items-center tw-h-8">
                        {!!this && !!this.props && !!this.props.isDownloadPDFExportFrontend !== false ? (
                          this.props.isDownloadPDFExportFrontend ? (
                            <Button variant="secondaryWithIcon" size="small" onClick={this.downloadUSExportsAnalyticsPDF.bind(this)} className="mr-2 tw-font-semibold tw-text-xs tw-flex tw-items-center">
                              <span className="material-symbols-outlined tw-w-5">cloud_download</span>
                              Download as PDF
                            </Button>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                        {!!this && !!this.props && !!this.props.isDownloadPDFExport !== false ? (
                          this.props.downloadAnalyticsPDF ? (
                            <Button variant="secondaryWithIcon" size="small" onClick={this.downloadAnalyticsPDF.bind(this)} className="mr-2 tw-font-semibold tw-text-xs tw-flex tw-items-center">
                              <span className="material-symbols-outlined tw-w-5">cloud_download</span>
                              Download as PDF
                            </Button>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {!readOnly ? (
                      <div className="col-md-6 text-right tw-flex tw-h-8 tw-justify-end">
                        <Button
                          variant="secondaryWithIcon"
                          size="small"
                          onClick={() => {
                            this.setShowFindWidget(this.state.showFindWidget);
                          }}
                          className="mr-2 tw-font-semibold tw-text-xs tw-flex tw-items-center">
                          <span className="material-symbols-outlined tw-w-5">frame_inspect</span>
                          Find Widget
                        </Button>
                        <Button
                          variant="secondaryWithIcon"
                          size="small"
                          onClick={() => {
                            this.setShowCustomiseWidget(this.state.showCustomiseWidget);
                          }}
                          className="mr-2 tw-font-semibold tw-text-xs tw-flex tw-items-center">
                          <span className="material-symbols-outlined tw-w-5">dashboard_customize</span>
                          Customize Analytics Widgets
                        </Button>
                      </div>
                    ) : (
                      <div className="col-md-6" />
                    )}
                  </div>
                )}
                {!this.state.isLoaderActive && !!this.state.analyticsData && this.state.analyticsData.length !== 0 && !!this.state.analyticsData.analysis && !!this.state.mainLabel ? (
                  <>
                    <div className="tw-flex tw-mb-4 tw-gap-4">
                      {this.props.analyticsHeaderItems && this.props.analyticsHeaderItems.length > 0 ? (
                        this.props.analyticsHeaderItems.map((item, index) => (
                          <div
                            className={`tw-flex tw-items-center ${this.props.analyticsHeaderItems.length === 1 || disableHeaderSelection ? "" : "tw-cursor-pointer"} tw-border tw-rounded-lg ${this.props.analyticsHeaderItems.length === 4 ? "!tw-w-full" : "!tw-w-[280px]"} !tw-h-[72px] tw-shadow-sm ${!disableHeaderSelection && this.state.search_type_options[this.state.analysisIndexKey]?.value === item?.key?.split("_").pop() ? "tw-bg-primary-purple-50 tw-border-primary-purple-100" : ""} `}
                            onClick={() => {
                              if (!disableHeaderSelection && this.props.analyticsHeaderItems.length > 1) {
                                this.bindGroupByResultValue(item?.key?.split("_").pop() ?? "shipments");
                              }
                            }}
                            key={item.key ?? index}>
                            <div className="tw-flex tw-flex-col tw-w-full tw-py-3 tw-px-4 tw-gap-1" {...(!disableHeaderSelection ? { "data-tip": `Analysis based on ${item.label}`, "data-for": "abc" } : {})}>
                              <div className="tw-flex tw-items-center tw-justify-between">
                                <span className={`tw-text-xs tw-font-medium ${!disableHeaderSelection && this.state.search_type_options[this.state.analysisIndexKey]?.value === item?.key?.split("_").pop() ? "!tw-text-primary-purple-600" : ""}`}>{item.label ? item.label : "NA"}</span>
                                {!disableHeaderSelection && (
                                  <span className={`tw-flex tw-w-5 tw-h-5 tw-border tw-border-gray-300 tw-rounded-xl tw-items-center tw-justify-center ${!disableHeaderSelection && this.state.search_type_options[this.state.analysisIndexKey]?.value === item?.key?.split("_").pop() ? "!tw-bg-primary-purple-600 tw-border-primary-purple-600" : ""}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill={`${!disableHeaderSelection && this.state.search_type_options[this.state.analysisIndexKey]?.value === item?.key?.split("_").pop() ? "white" : "#5f6368"}`}>
                                      <path d="M340.16-445.85v-298.23L224.77-628.69 188-665.85 366.15-844l178.16 178.15-36.77 37.16-115.39-115.39v298.23h-51.99ZM593.46-116 415.31-294.15l36.77-37.16 115.38 115.39v-298.23h52v298.23l115.39-115.39 36.76 37.16L593.46-116Z" />
                                    </svg>
                                  </span>
                                )}
                              </div>
                              <span className={`tw-font-semibold tw-text-base ${!disableHeaderSelection && this.state.search_type_options[this.state.analysisIndexKey]?.value === item?.key?.split("_").pop() ? "!tw-text-primary-purple-600" : ""}`}>{item.key && !!this.state.analyticsData[item.key] && this.state.analyticsData[item.key] !== "" ? `${item.valuePrefix ? item.valuePrefix : ""} ${numFormat(this.state.analyticsData[item.key])}  ${item.valueSuffix ? item.valueSuffix : ""}` : "NA"}</span>
                              {!disableHeaderSelection ? <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="abc" data-html={true} /> : null}
                            </div>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                    {/* -------------------------- end of top three header cards */}
                    <div ref={this.reference}>
                      <div className="analytics-card-deck">
                        {/* mapping chart data */}
                        {this.state.analyticsFieldKeys && this.state.analyticsFieldKeys.length > 0 ? (
                          this.state.analyticsFieldKeys.map((item, index) =>
                            this.state.analyticsData && item && item.key && this.state.analyticsData[item.key] && this.state.analyticsData[item.key].length > 0 ? (
                              // below is for trends
                              value.isSideBarOpen ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <ChartSkeleton />
                                </div>
                              ) : item.type === this.state.analyticsType.trends ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card ml-0" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-9 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900">{item.label}</div>
                                        <div className="col-md-3 text-right">
                                          <span className="no-btn p-0">{!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse ${item.label.split("(")[0].trim()} of all based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}</span>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="amcharts-graph-pdf">
                                      <LineChart data={this.state.analyticsData[item.key]} id={"lineChart" + index} mainLabel={this.state.mainLabel} color="#6f08f1" country="usanalytics" />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : // below is for country horiozontal
                              item.type === this.state.analyticsType.horizontalCountry ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card mr-0" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-6 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900 ">{item.label}</div>
                                        <div className="col-md-6 text-right">
                                          <div className="btn btn-link p-0 remove-block-for-pdf">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="p-0 amcharts-graph-pdf">
                                      <CategoryAxis analyticsFieldKeys={item.key} mainLabel={this.state.mainLabel} linegraphData={this.state.analyticsData[item.key]} id={"horizonalCountry" + index} country="usanalytics" mapClickedFilterKey={mapFilter} suppressChartFilterInteractions={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : // below is for horizontal bar
                              item.type === this.state.analyticsType.horizontalBar ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card ml-0" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-6 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900">{item.label}</div>
                                        <div className="col-md-6 text-right">
                                          <div className="btn btn-link p-0 remove-block-for-pdf">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="p-0 amcharts-graph-pdf">
                                      <SortedBarChart analyticsFieldKeys={item.key} mainLabel={this.state.mainLabel} id={"horizonalBar" + index} data={this.state.analyticsData[item.key]} mapClickedFilterKey={mapFilter} suppressChartFilterInteractions={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : // below is for vertical Bar
                              item.type === this.state.analyticsType.verticalBar ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-6 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900">{item.label}</div>
                                        <div className="col-md-6 text-right">
                                          <div className="btn btn-link p-0 remove-block-for-pdf">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="amcharts-graph-pdf">
                                      <HorizontalBar id={"verticalBar" + index} analyticsFieldKeys={item.key} mapClickedFilterKey={mapFilter} mainLabel={this.state.mainLabel} data={this.state.analyticsData[item.key]} suppressChartFilterInteractions={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : item.type === this.state.analyticsType.pieChart ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-6 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900">{item.label}</div>
                                        <div className="col-md-6 text-right">
                                          <div className="btn btn-link remove-block-for-pdf px-0">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="pt-0 amcharts-graph-pdf pie-chart-pdf">
                                      <NewPieChart id={"pieChart" + index} label={this.state.mainLabel === "Weight (kg)" ? "Kg" : this.state.mainLabel} analyticsFieldKeys={item.key} piegraphData={this.state.analyticsData[item.key]} mapClickedFilterKey={mapFilter} disabaleClick={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : item.type === this.state.analyticsType.hsCode ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-section-card" id={item.key}>
                                    <Card.Header className="border-bottom-0">
                                      <div className="row no-gutters">
                                        <div className="col-md-6 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900">
                                          {item.label}{" "}
                                          {item.infoText && item.infoText !== "" ? (
                                            <span>
                                              <Info
                                                className="mx-1"
                                                color="#8C8C8C"
                                                size={15}
                                                {...(!readOnly
                                                  ? {
                                                      "data-html": true,
                                                      "data-tip": "Analytics data is based on the summary of the shipments obtained through a search query.<br/> Hence the data may contain aggregated results for all products, HS Codes present in the search results.",
                                                      "data-for": "xyz",
                                                    }
                                                  : {})}
                                              />
                                            </span>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                        <div className="col-md-6 text-right">
                                          <div className="btn btn-link p-0 remove-block-for-pdf">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                        {!readOnly ? <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="xyz" data-html={true} /> : null}
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="top-shipments-pdf">
                                      <TopShipmentSection analyticsFieldKeys={item.key} mapClickedFilterKey={mapTopSection} headerLabel={item.headerLabel ? item.headerLabel : ""} data={this.state.analyticsData[item.key]} mainLabel={this.state.mainLabel} suppressChartFilterInteractions={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : item.type === this.state.analyticsType.topTwo ? (
                                <div className="mb-4 analytics-card-box" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-6 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900">{item.label}</div>
                                        <div className="col-md-6 text-right">
                                          <div className="btn btn-link p-0 remove-block-for-pdf">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="trade-route-pdf pt-0">
                                      <TradeRouteTwoLevel headerLabel={item.label} analyticsFieldKeys={item.key} mapClickedFilterKey={mapFilter} data={this.state.analyticsData[item.key]} mappingFieldData={item} mainLabel={this.state.mainLabel} suppressChartFilterInteractions={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : item.type === this.state.analyticsType.topThree ? (
                                <div className="mb-4 analytics-card-box analytics-card-box-full" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-8 my-auto">{item.label}</div>
                                        <div className="col-md-4 text-right">
                                          <div className="btn btn-link p-0 remove-block-for-pdf">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="trade-route-pdf pt-0">
                                      <TradeRouteThreeLevel analyticsFieldKeys={item.key} mapClickedFilterKey={mapFilter} data={this.state.analyticsData[item.key]} mappingFieldData={item} mainLabel={this.state.mainLabel} headerLabel={item.label} suppressChartFilterInteractions={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : item.type === this.state.analyticsType.topFour ? (
                                <div className="mb-4 analytics-card-box analytics-card-box-full" key={item.key}>
                                  <Card onMouseLeave={() => this.onMouseLeaveHandler()} onMouseOver={() => this.hoverGraphHandler(index)} className="new-table-card" id={item.key}>
                                    <Card.Header>
                                      <div className="row no-gutters">
                                        <div className="col-md-8 my-auto">{item.label}</div>
                                        <div className="col-md-4 text-right">
                                          <div className="btn btn-link remove-block-for-pdf px-0">
                                            {!readOnly && item.showTrends ? <span className="analytics-viewAll-container">{!readOnly && <button data-tip={`Analyse trade trends of all ${item.label.split("(")[0].trim()} based on their monthly, quarterly and yearly trade`} onClick={this.trendsModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-trends-btn-hover remove-block-for-pdf" : "analytics-viewAll-trends-btn remove-block-for-pdf"} />}</span> : <></>}
                                            {!readOnly && <button data-tip={`View all ${item.label.split("(")[0].trim()} based on their ranking`} onClick={this.detailModalShow.bind(this, item.key, item)} className={this.state.selectedIndex === index ? "analytics-viewAll-btn-hover remove-block-for-pdf" : "analytics-viewAll-btn remove-block-for-pdf"} />}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="trade-route-pdf pt-0">
                                      <TradeRouteFourLevel analyticsFieldKeys={item.key} mapClickedFilterKey={mapFilter} data={this.state.analyticsData[item.key]} mappingFieldData={item} mainLabel={this.state.mainLabel} suppressChartFilterInteractions={suppressChartFilterInteractions} />
                                    </Card.Body>
                                  </Card>
                                </div>
                              ) : (
                                <></>
                              )
                            ) : (
                              <>
                                {!!this && item && !!this.props && !!this.props.isDownloadPDFExportFrontend !== false && this.state.analyticsData[item.key]?.length ? (
                                  <div className="mb-4 analytics-card-box">
                                    <Card className="new-table-card ml-0" id={item.key}>
                                      <Card.Header>
                                        <div className="row no-gutters">
                                          <div className="col-md-9 my-auto !tw-text-sm !tw-font-medium !tw-text-gray-900">{item.label}</div>
                                          <div className="col-md-3 text-right" />
                                        </div>
                                      </Card.Header>
                                      <Card.Body className={item.type === this.state.analyticsType.hsCode ? "top-shipments-pdf empty-graph-pdf" : "amcharts-graph-pdf empty-graph-pdf"}>
                                        <div className="d-flex justify-content-center align-items-center h-100">
                                          <div>
                                            <span className="d-block text-center">
                                              <span className="no-result-icon pt-3 mb-4">
                                                <img className="no-search-icon" src="https://res.cloudinary.com/drzta9shk/image/upload/v1658434078/intel/icons/search-eye-line_iqznhd.svg" />
                                              </span>
                                            </span>
                                            <span>No Data Found.</span>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </>
                            )
                          )
                        ) : (
                          <></>
                        )}
                        <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <Row className="px-2 analytics-card-deck">
                  {this.state.isLoaderActive || this.props.isLoader
                    ? this.props.analyticsItems?.map((item) => (
                        <Col md={6} className="mb-4 px-2 analytics-card-box" key={item.key}>
                          <ChartSkeleton />
                        </Col>
                      ))
                    : null}
                </Row>
              </div>
              {this.state.showFindWidget && <AnalyticsSideDrawer country={this.props.country} analyticsFieldKeys={this.state.analyticsFieldKeys.filter((fieldKey) => Array.isArray(this?.props?.graphData[fieldKey?.key]) && this?.props?.graphData[fieldKey?.key].length > 0)} showFindWidget={this.state.showFindWidget} setShowFindWidget={(val) => this.setShowFindWidget(val)} />}
              {this.props?.analyticsDashletConfig?.length > 0 && this.state.showCustomiseWidget && <CustomizeAnalytics showCustomiseWidget={this.state.showCustomiseWidget} setShowCustomiseWidget={(val) => this.setShowCustomiseWidget(val)} analysis={this.props?.graphData?.analysis} sortAnalyticsWidgets={(arr) => this.sortAnalyticsWidgets(arr)} trade_direction={this.props?.trade_direction} country={this.props?.country} handleLoader={(e) => this.setState({ isLoaderActive: e })} analyticsCountryID={this.props.analyticsCountryID} pathname={this.props.pathname} currentUserPlan={this.props.currentUserPlan} gridCacheKey={this.props.gridCacheKey} />}
            </div>
          );
        }}
      </ContextData.Consumer>
    );
  }
}

function mapStateToProps(state) {
  const { analyticsDashletConfig } = state;
  return { selectedAnalyticsDashlet: analyticsDashletConfig?.selectedAnalyticsDashlet, analyticsDashletConfig: analyticsDashletConfig?.analyticsDashletConfig };
}

export default connect(mapStateToProps)(withRouter(GlobalAnalytics));
